/**
 * VI-717: white footer rendered inside JTScreener for jobseeker pages.
 * "Your Privacy Choices" opens DataGrail's categories layer via window.DG_BANNER_API
 * (injected at runtime by GTM). The API may be absent on environments without GTM
 * (e.g. localhost) — we no-op with a warning, matching the reference test-iframe.html.
 */

const PRIVACY_POLICY_URL = 'https://www.jobtarget.com/privacy-policy/';
const TERMS_OF_USE_URL = 'https://www.jobtarget.com/terms-of-use/';
const JOBTARGET_URL = 'https://www.jobtarget.com';

const showPrivacyChoices = () => {
  if (window.DG_BANNER_API && typeof window.DG_BANNER_API.showLayer === 'function') {
    window.DG_BANNER_API.showLayer('categories-layer');
  } else {
    console.warn('[JobseekerFooter] DG_BANNER_API not available — cannot open privacy choices.');
  }
};

const JobseekerFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="jobseeker-footer">
      <div className="jobseeker-footer__links">
        <a
          className="jobseeker-footer__link"
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <a
          className="jobseeker-footer__link"
          href={TERMS_OF_USE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>
        <button
          type="button"
          className="jobseeker-footer__link jobseeker-footer__privacy"
          onClick={showPrivacyChoices}
        >
          <span>Your Privacy Choices</span>
          <img
            className="jobseeker-footer__privacy-icon"
            src="/images/privacy-choices_logo.png"
            alt=""
            aria-hidden="true"
            draggable="false"
          />
        </button>
      </div>

      <a
        className="jobseeker-footer__copyright"
        href={JOBTARGET_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {year} © JobTarget
      </a>
    </footer>
  );
};

export default JobseekerFooter;
